<template>
  <div class="circle-icon" :style="circleStyles">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CircleIcon',
  props: {
    borderWidth: {
      type: String,
      default: '2px'
    },
    borderColor: {
      type: String,
      default: '#1370FF'
    }
  },
  computed: {
    circleStyles () {
      return {
        border: `${this.borderWidth} solid ${this.borderColor}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.circle-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 40px;
  height: 40px;

  @media (min-width: $screen-md) {
    width: 52px;
    height: 52px;
    margin-bottom: 25px;
  }
}
</style>
